import { createAction, props } from '@ngrx/store';
import { IApplicationModules } from 'src/app/core/models/admin/application/applicationmodules.model';
import { ApplicationModulesResponse } from './application-modules.models';

// Carga un solo módulo (payload: IApplicationModules)
export const loadApplicationModules = createAction(
  '[ApplicationModules] Load',
  props<{ payload: IApplicationModules }>(),
);

// Success: key = ApplicationGuid, modules = respuesta de la API (ApplicationModulesResponse)
export const loadApplicationModulesSuccess = createAction(
  '[ApplicationModules] Load Success',
  props<{ key: string; modules: ApplicationModulesResponse }>(),
);

export const loadApplicationModulesFailure = createAction(
  '[ApplicationModules] Load Failure',
  props<{ error: string; key: string }>(),
);

export const resetApplicationModules = createAction('[ApplicationModules] Reset');
export const refreshApplicationModules = createAction('[ApplicationModules] Refresh');
